import { Component, Input, OnInit } from '@angular/core';
import { TableColumnConfig } from '../table.columns';


@Component({
  selector: 'app-repeater',
  templateUrl: './repeater.component.html',
  styleUrls: ['./repeater.component.css'],
})
export class RepeaterComponent implements OnInit {
  @Input() columnConfigs: TableColumnConfig[];
  @Input() items: any[];
  @Input() pageItems: any[];
  pageSize = 1;

  constructor() {
  }
  onPageChanged(page) {
    const startIndex = (page - 1) * this.pageSize;
    //this.pageItems = _.take(_.rest(this.items, startIndex), this.pageSize);
  }

  ngOnInit() {
    const startIndex = 1;
    //this.pageItems = _.take(_.rest(this.items, startIndex), this.pageSize);
  }
}
